import { TOfferCategory } from '../../../../types/offer';

export function getIsDailyRent(category: TOfferCategory | null): boolean {
  return category ? category.indexOf('daily') > -1 : false;
}
